import { cacheLastSearchResult } from '@/modules/common/helpers/cache-search-result.helper';
import {
  indicateWheatType,
  multiWheatType,
} from '@/modules/common/helpers/wheat-type.helper';
import { validateModal } from '@/modules/mixing/components/mixing-by-params-modal/utils';
import { fetchMixingParamsData } from '@/widgets/recipe/model';
import { notification } from 'antd';
import { NavigateFunction } from 'react-router-dom';
import { ISearchState } from '../ts/index.types';
import { IAgricultureParameter } from '@/modules/agriculture/ts';

export const submitFx = async ({
  searchState,
  navigate,
  resultData,
  wheatForValidation,
}: {
  searchState: ISearchState;
  navigate: NavigateFunction;
  resultData: any;
  wheatForValidation: {
    gluten: IAgricultureParameter;
    humidity: IAgricultureParameter;
    idk: IAgricultureParameter;
    cp: IAgricultureParameter;
    protein: IAgricultureParameter;
    nature: IAgricultureParameter;
  };
}) => {
  const checkedWarehouses = searchState?.stores?.filter(
    (item) => item.checked === true,
  );
  const validationResult = validateModal(searchState, wheatForValidation);
  if (validationResult.errors.length > 0)
    notification.warning({
      message: `Не заданы значения для полей: ${validationResult.errors.join(', ')}`,
    });
  if (validationResult.warnings.length > 0)
    validationResult.warnings.map((item) =>
      notification.warning({
        message: item.label,
      }),
    );

  if (validationResult.success) {
    const wheatType = indicateWheatType(
      searchState.wheatData.sort,
      searchState.wheatData.type,
    );
    const params = {
      warehouse_id: checkedWarehouses.map((item) => item.id),
      cp: +searchState.wheatData.params.cp,
      nature: +searchState.wheatData.params.nature,
      humidity: parseFloat(searchState.wheatData.params.humidity as any),
      protein: parseFloat(searchState.wheatData.params.protein as any),
      gluten: +searchState.wheatData.params.gluten,
      idk: +searchState.wheatData.params.idk,
      deviation: +searchState.wheatData.divergence,
      class: +searchState.wheatData.class,
      type: wheatType || undefined,
      //temperature: 24,
    };
    const urlParams = new URLSearchParams(params as any).toString();
    // try {
    //   await fetchMixingParamsData(params);
    // } catch (err) {
    //   return;
    // }

    if (resultData?.errors) {
      const errorArray = Object.entries(resultData?.errors)?.flatMap(
        ([key, value]) => value,
      );
      errorArray.map((item) =>
        notification.warning({
          message: String(item),
        }),
      );
      return;
    }
    // navigate(`/mixing/manual?${urlParams}`)
    cacheLastSearchResult(`/mixing/manual?${urlParams}`);
    navigate({ pathname: '/mixing/manual', search: urlParams });
  }
};
